// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-component=\"UiRelativeDate\"][data-v-05629785]{text-decoration:underline dotted;cursor:help}\n", ""]);
// Exports
module.exports = exports;
